import { render, staticRenderFns } from "./HomeV2.vue?vue&type=template&id=4992a765"
import script from "./HomeV2.vue?vue&type=script&lang=js"
export * from "./HomeV2.vue?vue&type=script&lang=js"
import style0 from "./HomeV2.vue?vue&type=style&index=0&id=4992a765&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports